// extracted by mini-css-extract-plugin
export var box = "_5j-0";
export var check = "_5j-1";
export var checkboxButton = "_5j-6";
export var checkboxGroup = "_5j-5";
export var disabled = "_5j-7";
export var ghost = "_5j-9";
export var input = "_5j-2";
export var label = "_5j-4";
export var normal = "_5j-8";
export var uncheck = "_5j-3";